/* eslint-disable no-param-reassign */
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store/store';
import { fmsrService } from 'app/services/fmsrService/fmsrService';
import { Language } from 'i18n';
import { jwtDecode } from 'jwt-decode';
import toast from 'react-hot-toast';
import { Workstation } from '../app/services/fmsrService/fmsr.types';

type DecodedJwt = { firebase?: { sign_in_attributes?: { locale: string } } };

export const getLocaleFromJwt = (data: string) => {
  const decodedJwt: DecodedJwt = jwtDecode(data);
  return decodedJwt?.firebase?.sign_in_attributes?.locale?.toLowerCase()?.substring(0, 2) as Language || 'pt';
};

const initialState: Workstation = {
  countryCode: '',
  businessUnitId: '',
  workstationId: '',
  operatorId: '',
  tenantId: '',
  jwt: '',
};

const workstationSlice = createSlice({
  name: 'workstation',
  initialState,
  reducers: {
    clearWorkstation: () => initialState,
    setJwt: (state, action) => {
      state.jwt = action.payload;
      localStorage.setItem('fmsrToken', action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      fmsrService.endpoints.registerTransaction.matchFulfilled,
      (state, { payload }) => {
        toast.success(payload.localizedText);
      },
    );
  },
});
export const { clearWorkstation, setJwt } = workstationSlice.actions;

export const selectJwt = (state: RootState) => state.workstation.jwt;
export const selectWorkstation = (state: RootState) => state.workstation;
export const selectBusinessUnitId = (state: RootState): string => state.workstation.businessUnitId;
export const selectLocale = createSelector(selectJwt, (jwt): Language => jwt ? getLocaleFromJwt(jwt) : 'pt');

export default workstationSlice.reducer;
